/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Phone, AlertTriangle, ShieldAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

export const RedFlagBanner = ({ assistant }) => {
  if (!assistant?.emergency && !assistant?.red_flag) return null;
  const isEmergency = !!assistant?.emergency;
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="symptom-redflag-banner"
      className={cn(
        'rounded-2xl border p-4 md:p-5 flex items-start gap-3 shadow-md',
        isEmergency
          ? 'bg-red-500/10 border-red-500/40 text-red-800 dark:text-red-200'
          : 'bg-amber-500/10 border-amber-500/40 text-amber-800 dark:text-amber-200'
      )}
    >
      {isEmergency ? <ShieldAlert className="h-6 w-6 flex-shrink-0 mt-0.5" /> : <AlertTriangle className="h-6 w-6 flex-shrink-0 mt-0.5" />}
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-base">
          {isEmergency ? 'Attenzione: possibile emergenza medica' : 'Segnale d’allarme rilevato'}
        </div>
        <div className="text-sm mt-1 opacity-90">
          {isEmergency
            ? 'I sintomi descritti richiedono valutazione medica immediata. Chiama il 118 o recati al Pronto Soccorso più vicino.'
            : 'Suggeriamo di consultare un medico al più presto per una valutazione clinica.'}
        </div>
        {isEmergency && (
          <div className="mt-3 flex flex-wrap gap-2">
            <a href="tel:118">
              <Button size="sm" className="bg-red-600 hover:bg-red-700 text-white" data-testid="call-118-btn">
                <Phone className="h-4 w-4" /> Chiama 118
              </Button>
            </a>
          </div>
        )}
      </div>
    </motion.div>
  );
};
